import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import React, { useState } from "react";
import { formatCurrency, formatDate } from "../../../utils/utils";
import { tableCellStyles, tableHeaderStyles } from "../../../utils/styles";

const EmiDetails = ({ data }: { data: any }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const records = data || [];
  const paginatedRecords = records.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Paper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={tableHeaderStyles}>Date</TableCell>
              <TableCell sx={tableHeaderStyles}>Amount</TableCell>
              <TableCell sx={tableHeaderStyles}>Number</TableCell>
              <TableCell sx={tableHeaderStyles}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRecords.length > 0 ? (
              paginatedRecords.map((emi: any) => (
                <TableRow key={emi.id}>
                  <TableCell sx={tableCellStyles}>
                    {formatDate(emi.emiDate)}
                  </TableCell>
                  <TableCell sx={tableCellStyles}>
                    {formatCurrency(emi.emiAmount)}
                  </TableCell>
                  <TableCell sx={tableCellStyles}>{emi.emiNumber}</TableCell>
                  <TableCell
                    sx={{
                      ...tableCellStyles,
                      color: emi.isPaid ? "success.main" : "error.main",
                    }}
                  >
                    {emi.isPaid ? "Paid" : "Pending"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} sx={{ textAlign: "center" }}>
                  No emi record found for this vehicle
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {records.length > 10 && (
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={records.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
        />
      )}
    </Paper>
  );
};

export default EmiDetails;
